import * as React from 'react';

import { Alert } from '@lightspeed/flame/Alert';
import { Text } from '@lightspeed/flame/Text';

import { downloadImportErrorFileURL } from '../../utils/helper-url';

interface Props {
  totalErrors: string | undefined;
}

const ImportErrorFile: React.FC<Props> = ({ totalErrors }) => {
  const systemCustomerId = window.merchantos.session.getSystemCustomerID() as string;
  const { id: countId } = window.history.getFilters();

  return (
    <Alert data-test="alert-error-import-validation-file" type="danger" noCloseBtn mb={2}>
      <Text>
        This file has <var>{totalErrors}</var> items with errors.
      </Text>
      <Text>
        <a
          data-test="download-error-file-link"
          href={
            systemCustomerId && countId ? downloadImportErrorFileURL(systemCustomerId, countId) : ''
          }
          target="_blank"
          rel="noopener noreferrer"
          style={{ fontWeight: 600, textDecoration: 'none' }}
        >
          Download this file
        </a>
        , fix the errors and reimport the file.
      </Text>
    </Alert>
  );
};

export default ImportErrorFile;
